/* eslint-disable @typescript-eslint/no-unused-vars */
import { createApi } from "@reduxjs/toolkit/query/react";
import { components } from "../../types/api";
import { baseQueryWithReauth } from "../../utils/baseQuery";

// Define types from the API schema
type SystemStats = components["schemas"]["SystemStats"];
type ServiceHealth = components["schemas"]["ServiceHealth"];
type PubSubStatus = components["schemas"]["PubSubStatus"];
type DatabaseStats = components["schemas"]["DatabaseStats"];

// Define response types
type SystemStatsResponse = components["schemas"]["ApiResponse_SystemStats_"];
type ServiceHealthResponse =
  components["schemas"]["ApiResponse_ServiceHealth_"];
type PubSubStatusResponse = components["schemas"]["ApiResponse_PubSubStatus_"];
type DatabaseStatsResponse =
  components["schemas"]["ApiResponse_DatabaseStats_"];

export const systemStatsApi = createApi({
  reducerPath: "systemStatsApi",
  baseQuery: baseQueryWithReauth,
  tagTypes: ["SystemStats"],
  endpoints: (builder) => ({
    // Get all system stats (services, resources, pubsub, database)
    getSystemStats: builder.query<SystemStatsResponse, void>({
      query: () => "/system-stats",
      providesTags: ["SystemStats"],
    }),

    // Get health of a specific service
    getServiceHealth: builder.query<ServiceHealthResponse, string>({
      query: (service) => `/system-stats/health/${service}`,
      providesTags: ["SystemStats"],
    }),

    // Get PubSub status
    getPubSubStatus: builder.query<PubSubStatusResponse, void>({
      query: () => "/system-stats/pubsub",
      providesTags: ["SystemStats"],
    }),

    // Get database stats
    getDatabaseStats: builder.query<DatabaseStatsResponse, void>({
      query: () => "/system-stats/database",
      providesTags: ["SystemStats"],
    }),
  }),
});

export const {
  useGetSystemStatsQuery,
  useGetServiceHealthQuery,
  useGetPubSubStatusQuery,
  useGetDatabaseStatsQuery,
} = systemStatsApi;
